import { useNavigate } from 'react-router-dom';
import { Card, Stack, Typography } from '@mui/material';
import { TopNextButton } from 'components';
import UnlimitedIcon from 'components/icons/Unlimited';
import { SpeechDiagonal } from 'pages/Top/style';
import { baseColors } from 'utils/constants';

type Props = {
  mainBodyImage: string;
  price: number;
  title: string;
  subText: string;
  subText2: string;
  plan?: string;
};

const PlanCard = (props: Props) => {
  const { mainBodyImage, price, title, subText, subText2, plan } = props;
  const navigate = useNavigate();
  const handleNext = (): void => {
    const path = plan ? `/rental/ec?plan=${plan}` : `/rental/ec`;
    navigate(path);
  };

  return (
    <Card sx={{ width: '300px', paddingBottom: '20px' }}>
      <Typography
        variant="h5"
        sx={{
          color: baseColors.white,
          fontSize: '18px',
          backgroundColor: baseColors.darkBlue,
          borderRadius: '10px 10px 0 0',
          padding: '10px 0',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        <div
          style={{
            display: 'inline-block',
            position: 'absolute',
            top: '0.75rem',
            left: '0.5rem'
          }}
        >
          <UnlimitedIcon />
        </div>
        {title}
      </Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{
          padding: '20px 10px 0 10px',
          justifyContent: 'space-around',
          alignItems: 'center'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src={mainBodyImage} alt="mobile-router" style={{ paddingBottom: '10px', maxHeight: '130px' }} />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Typography
            variant="body1"
            sx={{
              textDecoration: 'underline',
              textDecorationColor: baseColors.red,
              textDecorationThickness: '2px',
              textUnderlineOffset: '4px'
            }}
          >
            {subText}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: 'underline',
              textDecorationColor: baseColors.red,
              textDecorationThickness: '2px',
              textUnderlineOffset: '4px'
            }}
          >
            {subText2}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              padding: '10px 0',
              display: 'flex',
              justifyContent: 'center',
              color: baseColors.red,
              fontWeight: 'bold'
            }}
          >
            <span style={{ fontSize: '46px' }}>{price}</span>
            <span>
              <span style={{ fontSize: '12px' }}>(税込)</span>
              <br />
              <span style={{ fontSize: '20px' }}>円/日</span>
            </span>
          </Typography>
        </div>
      </Stack>
      <Typography
        component="div"
        variant="body1"
        sx={{
          textAlign: 'center',
          fontSize: '12px',
          color: baseColors.blackGray
        }}
      >
        <SpeechDiagonal>7日以上でさらにお得！</SpeechDiagonal>
      </Typography>
      <TopNextButton onClick={handleNext} />
    </Card>
  );
};
export default PlanCard;
